<template>
  <div class="addWarehouse formStyel myinput">
    <el-form :model="form" ref="form" label-width="130px">
      <el-row  v-show="activeName=='first'">
        <el-col :span="11">
          <el-form-item label="仓库:">
            <el-input maxlength="100" style="width:390px" v-model="form.depotName" autocomplete="off"
              placeholder="请输入仓库名称"></el-input>
          </el-form-item>
          <el-form-item label="地址:">
            <el-input maxlength="150" style="width:390px" v-model="form.address" placeholder="请输入地址信息"></el-input>
          </el-form-item>
          <el-form-item label="图片(1080*763)" ref="uploadElement" prop="imgURL" class="upimg">
            <template>
              <ul class="el-upload-list el-upload-list--picture-card" v-if="form.pictureLink">
                <li v-for="(i, index) in form.pictureLink" :key="index" class="el-upload-list__item">
                  <img width="100%" height="100%" :src="i" v-if="form">
                  <span class="delect-icon" @click.stop="removeImg(index)"><i class="el-icon-delete"
                      style="font-size: 16px"></i></span>
                </li>
              </ul>
            </template>
            <el-upload :class="['uploader', pic > 3 ? 'picall' : '']" :action="uploadUrl" :http-request="myupload"
              list-type="picture-card" accept="image/*" :before-upload="onBeforeUpload" :limit="3"
              :on-preview="handlePictureCardPreview">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="true" append-to-body>
              <img width="100%" :src="imgURL" alt="" v-if="imgURL">
            </el-dialog>
          </el-form-item>

          <el-form-item label="是否需要审批:">
            <el-radio-group v-model="form.isNeedApprove">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="审批节点:" v-if="form.isNeedApprove == 1">
            <template>
              <ul>
                <li v-for="item, index in form.node" :key="index">
                  <span>节点{{ index + 1 }}</span>
                  <el-select size="mini" v-model="item.userId" placeholder="请选择">
                    <el-option v-for="row in userList" :key="row.userId" :label="row.name" :value="row.userId">
                    </el-option>
                  </el-select>
                  <i v-if="index > 0" class="el-icon-circle-close" @click="delHierarchy(index, 'node')"></i>
                  <i class="el-icon-circle-plus-outline" @click="addHierarchy('node')"></i>
                </li>
              </ul>
            </template>

          </el-form-item>
           <el-form-item label="仪器二堆码上是否绑定格口号信息:" label-width="240px" prop="showBox">
              <el-radio-group v-model="form.showBox">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          <el-form-item label="备注信息:">
            <el-input v-model="form.remark" style="width:390px" maxlength="300" placeholder="请输入备注信息" type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="13">
          <el-form-item label="定位:">
            <el-input placeholder="请输入定位地址" prefix-icon="el-icon-search" @change="onSearchMap" v-model="form.location">
            </el-input>
          </el-form-item>
          <div style="display: flex;">
            <el-form-item label="经度:">
              <el-input placeholder="请点击地图选点获取经度" :disabled="true" v-model="form.longitude">
              </el-input>
            </el-form-item>
            <el-form-item label="纬度:" style="margin-left: 25px;">
              <el-input placeholder="请点击地图选点获取纬度" :disabled="true" v-model="form.latitude">
              </el-input>
            </el-form-item>
          </div>
          <el-form-item label="">
            <div ref="mapDetail" id="mapDetail" style="width: 100%; height: 450px;"></div>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-show="activeName=='second'">
        <el-form-item label="SN码:">
          <el-input placeholder="请输入唯一的SN码" style="width:390px" v-model="form.sn">
          </el-input>
        </el-form-item>
        <el-form-item label="温湿度传感器配置:">
          <el-switch v-model="form.isThermometer" active-color="#409eff" inactive-color="#ccc">
          </el-switch>
        </el-form-item>
        <template v-if="form.isThermometer == true">
          <ul>
            <li v-for="item, index in form.thermometerList" :key="index">
              <div>
                <span>温湿度传感器名称：</span>
                <el-input style="width: 250px;" size="small" placeholder="请输入" v-model="item.thermometerName">
                </el-input>
              </div>
              <div style="margin-left: 10px;">
                <span>EUI：</span>
                <el-input style="width: 250px;" size="small" placeholder="请输入" v-model="item.eui">
                </el-input>
              </div>
              <i v-if="index > 0" class="el-icon-circle-close" @click="delHierarchy(index, 'thermometer')"></i>
              <i class="el-icon-circle-plus-outline" @click="addHierarchy('thermometer')"></i>
            </li>
          </ul>
        </template>
        <el-form-item label="视频监控配置:">
          <el-switch v-model="form.isEquipment" active-color="#409eff" inactive-color="#ccc">
          </el-switch>
        </el-form-item>
        <template v-if="form.isEquipment == true">
          <ul>
            <li v-for="item, index in form.equipmentList" :key="index">

              <div>
                <span>通道名称：</span>
                <el-input style="width: 250px;" size="small" placeholder="请输入" v-model="item.channelName">
                </el-input>
              </div>
              <div style="margin-left: 10px;">
                <span>通道号：</span>
                <el-input style="width: 250px;" size="small" placeholder="请输入" v-model="item.channelNo">
                </el-input>
              </div>
              <div style="margin-left: 10px;">
                <span>序列号：</span>
                <el-input style="width: 250px;" size="small" placeholder="请输入" v-model="item.deviceSerial">
                </el-input>
              </div>
              <i v-if="index > 0" class="el-icon-circle-close" @click="delHierarchy(index, 'equipment')"></i>
              <i class="el-icon-circle-plus-outline" @click="addHierarchy('equipment')"></i>
            </li>
          </ul>
        </template>
      </div>
    </el-form>
    <div class="row-item footer" style="width:100%; margin-top: 10px;text-align: center;">
      <div class="element-list jb-bg btn" @click="submit('form')">确认</div>
      <div class="element-list btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
import { FileUrl, locationIp, suggestion } from "@/api/depotApi";
import { getUserInfo } from "@/api/userApi";
import axios from '@/util/request';
export default {
  name: "addWarehouse",
  props: {
    activeName: {
      type: String, 
      default: 'first'
    },
    propsForm:{
      type: Object,
      default: {}
    }

  },
  components: {},
  data() {
    return {
      uploadUrl: "/admin/sys-file/upload", //上传地址
      imgURL: '',//在线地址
      dialogVisible: false,
      userList: [],
      loading: false,
      addressList: [],
      map: "",
      pic: 0,//已有图片数量
      form: {
      },
      ad_info: null,
      pic: 0,//已有图片数量
      fileList: [], // 文件临时存放列表
    };
  },

  created() {
    this.getList()
    this.getInfo()
    
  },
  mounted() {
    if (this.pic >= 3) {
      this.d('none')
    }
    setTimeout(() => {
      this.initMap();
    }, 500)
  },
  // https://apis.map.qq.com/ws/location/v1/ip?key=DQYBZ-IDL3L-JGUPJ-MNQZG-2J2H6-SDBHW
  computed: {
    deptId() {
      return this.$store.state.user.userInfo.deptId
    }
  },
  methods: {
    getInfo(){
      this.form.deptId = this.$store.state.user.userInfo.deptId;
    if (this.propsForm && this.propsForm.id) {
   
      let { equipmentList, thermometerList, depotName, key, address, longitude, latitude, range, remark, sn, picture, deptId, id,showBox, location, isNeedApprove, openDeliver, reviewNodes
      } = { ...this.propsForm }
      this.form = {isEquipment:false,isThermometer:false, equipmentList,thermometerList,showBox,isNeedApprove, openDeliver, depotName, key, address, sn, longitude, latitude, range, remark, picture, deptId, id, location }
      let node = reviewNodes ? reviewNodes.map(it => {
        return {
          userId: it.id.toString()
        }
      }) : [
        {
          userId: null
        }
      ]
      this.$set(this.form, 'node', node)
      if(equipmentList.length){
        this.form.isEquipment = true
      }
      if(equipmentList.length===0){
        this.form.equipmentList = [{ channelName: '', channelNo: '', deviceSerial: '', }]
      }
      if(thermometerList.length){
        this.form.isThermometer = true
      }
      if(thermometerList.length===0){
        this.form.thermometerList = [{ thermometerName: '', eui: '' }]
      }
      this.form.pictureLink = this.propsForm.pictureLink||[]
      this.pic = this.propsForm.pictureLink.length
      if (this.propsForm.picture && this.propsForm.picture.length > 5) {
        this.fileList = this.propsForm.picture.split(',')
      }
    }else{
      this.form = Object.assign({ showBox: 0 }, this.propsForm)
    }
    },
    d(val) {
      let upl = document.querySelector('.el-upload')
      upl.style.display = val
    },
    onSearchMap(value) {
      let self = this
      self.form.longitude = '', self.form.latitude = ''
      self.map.removeOverlay(self.markerPoint)
      self.map.centerAndZoom(value, 16)
    },
    initMap() {
      let self = this;
      const map = new BMap.Map(this.$refs.mapDetail);
      const geocoder = new BMap.Geocoder();
      let point = new BMap.Point(104.720497, 34.385884);
      map.centerAndZoom(self.form.location ? self.form.location : point, self.form.location ? 16 : 5)
      map.enableScrollWheelZoom(true);
      self.map = map;
      map.addEventListener('click', function (e) {
        geocoder.getLocation(e.point, function (rs) {
          if (rs && rs.address) {
            self.form.location = rs.content.poi_desc; // 更新地址信息
          }
        })
        self.$set(self.form, 'latitude', e.point.lat)
        self.$set(self.form, 'longitude', e.point.lng)
        self.addTag()
      });
    },
    addTag() {
      let self = this
      self.map.removeOverlay(self.markerPoint)
      let point = new BMap.Point(self.form.longitude, self.form.latitude)
      let marker = new BMap.Marker(point)
      self.markerPoint = marker
      self.map.addOverlay(marker)
    },
    //触发关键词输入提示事件
    remoteMethod(query) {
      this.getsuggest(query)
    },
    getsuggest(e) {
      if (e.length <= 0) {
        //用于接收地址列表的数组，在data声明
        this.addressList = []
        return;
      }
      this.loading = true;
      //在执行这一步之前要配置跨域，不然会报错
      suggestion(
        {
          key: 'DQYBZ-IDL3L-JGUPJ-MNQZG-2J2H6-SDBHW',
          keyword: e,
          region: this.ad_info.city || '广州',
          output: 'json'
        }
      ).then(res => {
        this.loading = false;
        //成功返回的信息
        console.log(res);
        this.addressList = res.data;
      })
        .catch(err => {
          console.log(err)
          this.$message.error(err);
        });
    },

    getCity() {
      locationIp({ key: 'DQYBZ-IDL3L-JGUPJ-MNQZG-2J2H6-SDBHW' }).then(res => {
        this.ad_info = res.result.ad_info

      })
    },
    // 获取用户列表
    getList() {
      let params = {
        deptId: this.deptId,
        lockFlag: 1,
        current: 1,
        size: 3000,
      };
      getUserInfo(params).then(res => {
        if (res.code == 200) {
          this.userList = res.data.records.filter(it => it.roleId == 1 || it.roleId == 2)

        } else {
          this.$message.error(res.msg || "服务器连接失败");
        }
      }).catch((err) => {
        this.$message.error(err.msg || err.message || "服务器连接失败");
      });
    },
    addHierarchy(type) {
      switch (type) {
        case 'equipment':
          this.form.equipmentList.push({ channelName: '', channelNo: '', deviceSerial: '', })
          break;
        case 'thermometer':
          this.form.thermometerList.push({ thermometerName: '', eui: '' })
          break;

        default:
          this.form.node.push({ userId: null })
          break;
      }
    },
    delHierarchy(index, type) {
      switch (type) {
        case 'equipment':
          this.form.equipmentList.splice(index, 1)
          break;
        case 'thermometer':
          this.form.thermometerList.splice(index, 1)
          break;

        default:
          this.form.node.splice(index, 1)
          break;
      }
    },
    //提交仓库信息
    submit(form) {
      let falt = true
      if (this.form.depotName.trim() == "") {
        this.$message.error(`仓库名不能为空`);
        return false;

      }

      if (this.form.address.trim() == "") {
        this.$message.error(`地址不能为空`);
        return false;
      }

      this.form.reviewers = []
      if (this.form.isNeedApprove == 1) {

        for (let index = 0; index < this.form.node.length; index++) {
          const element = this.form.node[index];
          if (!element.userId) {
            falt = false
            this.$message.error(`请选择节点${index + 1}`);
            return false;
          } else {
            this.form.reviewers.push(element.userId)

          }
        }
      }
      this.$emit('submit', this.form)
    },
    cancel() {
      this.$emit('cancel')
    },
    myupload(item) {
      let that = this;
      let fileObj = item.file;
      const form = new FormData();
      form.append("file", fileObj);
      axios({
        url: item.action,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        if (res.succeed) {
          that.fileList.push(res.data.fileName);
          that.form.picture = that.fileList.toString()
          FileUrl({ objectName: res.data.fileName }).then((res) => {
            that.imgURL = res.data;
            that.pic++;
            if (that.pic >= 3) {
              that.d('none')
            }
          });
        }
        else {
          if (res.code === '401') {
            that.$message.error('登录过期，请重新登录！');
            setTimeout(() => {
              window.sessionStorage.clear();
              window.localStorage.clear();
              window.location.href = "/login";
            }, 1000);
            that.$message.destroyed();
            return false;
          }
          else {
            that.$message.error(res.msg);
          }
        }
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传图片!");
      });
    },
    //图片删除
    // handleRemove(file, fileList) {
    //   const index = this.form.fileList.findIndex(i => i.uid == file.uid);
    //   this.form.fileList.splice(index, 1);
    //   this.fileList.splice(index, 1);
    //   this.form.picture = this.fileList.toString()
    // },
    //图片删除
    handleRemove(file, fileList) {
      console.log('handleRemove', file, fileList);
      this.pic--
      if (this.pic < 3) {
        this.d('block')
      }
    },
    removeImg(val) {
      this.pic--
      if (this.pic < 3) {
        this.d('block')
      }
      this.fileList.splice(val, 1);
      this.form.pictureLink.splice(val, 1)
      this.form.picture = this.fileList.toString()
    },
    //图片放大
    handlePictureCardPreview(file) {
      this.imgURL = file.url;
      this.dialogVisible = true;
    },
    //图片上传前检查
    onBeforeUpload(file, fileList) {
      let _this = this;
      const isTypeTrue = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt300K = file.size / 1024 < 4096;
      if (!isLt300K) {
        this.$message.error("上传图片大小不能超过4M!");
        return false;
      }
      if (!isTypeTrue) {
        this.$message.error("上传图片格式不对!");
        return false;
      } else {
        return new Promise((resolve, reject) => {
          let width = 1080;
          let height = 763;
          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
              const isValidResolution = img.width != width && img.height != height;
              if (isValidResolution) {
                this.$message.error('上传的图片必须是1080*763像素!请重新选择图片');
                reject(new Error('Resolution is too low'));
              } else {
                resolve(true);
              }
            };
            img.src = e.target.result;
          };
          reader.readAsDataURL(file);
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.addWarehouse {
  color: #74c8fe;
  height: 700px;
  overflow-y: auto;
  max-height: 700px;

  /deep/ .el-form-item {
    margin-bottom: 15px;
  }

}

.addWarehouse::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}

.addWarehouse::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #86cbfd;
}

.addWarehouse::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #1f94f1;
}

.el-col-4 {
  margin-right: 10px;
}

.selectinfo {
  .el-scrollbar .el-scrollbar__wrap .el-select-dropdown__list .el-select-dropdown__item {
    height: 50px;

    span {
      display: block;
      height: 20px;
    }
  }
}

.footer {
  display: flex;
  justify-content: center;

  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }

  .element-list {
    border: 2px solid#0090F0;
    border-radius: 6px;
    height: 30px;
    line-height: 30px;
    margin: 10px 0;
    text-align: center;
  }

  .btn {
    width: 150px;
    margin-right: 10px;
    cursor: pointer;
  }
}

.upimg /deep/.el-form-item__content {
  display: flex;
}

.picall {
  display: none;
}

.uploader {
  display: flex;
}

.formStyel {
  /deep/ .el-form-item__label {
    color: #74c8fe;
  }

  /deep/ .el-form {
    margin-top: 15px;
  }

}

//弹框label
/deep/.el-form-item__label {
  text-align: justify;
  text-align-last: justify;
  width: 120px;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/deep/.el-upload--picture-card i {
  font-size: 16px;
  color: #8c939d;
}

/deep/.avatar {
  display: block;
}

/deep/.el-upload--picture-card {
  background-color: #092e5f;
  border: 2px solid #018be9;
  ;
}

.delect-icon {
  text-align: center;
  width: 23px;
  height: 23px;
  border-radius: 6px;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
}

ul {
  display: flex;
  flex-direction: column;

  li {
    display: flex;
    align-items: center;
    list-style: none;
    margin-bottom: 10px;

    span {
      margin-right: 10px
    }

    .el-icon-circle-close,
    .el-icon-circle-plus-outline {
      font-size: 18px;
      margin-left: 15px;
    }
  }
}

#mapDetail {
  width: 100%;
  height: 500;
  margin-bottom: 36px;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/addWarehouse.vue